import { render, staticRenderFns } from "./AdminAssessment.vue?vue&type=template&id=52fe1bea&"
import script from "./AdminAssessment.vue?vue&type=script&lang=js&"
export * from "./AdminAssessment.vue?vue&type=script&lang=js&"
import style0 from "./AdminAssessment.vue?vue&type=style&index=0&id=52fe1bea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports